import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import AddButton from "../../AdminPanel/Component/UI/AddButton";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import CommonTableTeam from "../../AdminPanel/Component/UI/CommonTableTeam";
import Tooltip from "../../AdminPanel/Component/UI/Tooltip";
import AddCampaignsModal from "./Component/AddCampaignsModal";
import UpdateCampaignsModal from "./Component/UpdateCampaignsModal";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { HiMiniPlus } from "react-icons/hi2";
import { BsBarChartLine } from "react-icons/bs";
import { LuAlarmClock } from "react-icons/lu";
import { assessmentActions, userActions } from "../../../_actions";
import moment from 'moment';


class MyCampaigns extends Component {

  constructor(props) {
    super(props);
    this.state = {
      addCampaignsModal: false,
      updateUserModal: false,
      entries: 20,
      formData: {
        title: "",
        subject: "",
        message: "",
        teamId: "",
        assessment: "644abb4b1236ff3f408634d1",
        productList: ["644abb4b1236ff3f408634d1"],
        type: "team",
        list: [],
        stage: 1
      },
      pageNo: 1,
      size: 10,
      keyWord: "",
      crrCodeObj: {
        id: "", title: "", count: 0
      }
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAvailableCodeCount());
    this.props.dispatch(assessmentActions.getAssessmentProducts());

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }

    this.props.dispatch(assessmentActions.getCoachCampaignList(temp));
    const temp2 = {
      keyWord: "",
      pageNo: 1,
      size: 10
    }
    this.props.dispatch(assessmentActions.getTeamList(temp2));
    this.callUserListAPI();
  }

  handleInputChange = (e, save) => {
    let { formData } = this.state;
    let name = e.target.name;
    let value = e.target.value;

    let title = e.target.title;
    let count = e.target.count;

    if (save === 2) {
      console.log("e-----x----->", e)
    }

    if (name === "type" || name === "teamId") {
      formData[name] = value.value;
    } else {
      formData[name] = value;
    }
    if (save === 2) {
      this.setState({ crrCodeObj: { id: value, title: title, count: count } })
    }

    this.setState({ formData })
  }

  openAddCampaignsModal = () => {
    this.setState({ addCampaignsModal: true }, () => {
    });
  };

  closeAddCampaignsModal = (type) => {
    if (type === "prev") {
      let { formData } = this.state;
      this.setState({ formData: { ...formData, stage: 1 } });
    } else {
      this.setState({ addCampaignsModal: false });

    }
  };

  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  openUpdateCampaignsModal = () => {
    this.setState({ updateUserModal: true });
  };

  closeUpdateCampaignsModal = () => {
    this.setState({ updateUserModal: false });
  };

  handleReupload = () => {
    // console.log("Reupload clicked");
    this.setState({ updateUserModal: false });
  };

  onSubmitForm = (codeInitobj) => {
    let { formData, crrCodeObj } = this.state;
    if (formData && formData.teamId) {
      const temp = {
        teamId: formData.teamId,
        keyWord: "",
        pageNo: 1,
        size: 10000
      }
      this.props.dispatch(assessmentActions.getMyUserList(temp));
      this.setState({ formData: { ...formData, stage: 2 } });
      if (!(crrCodeObj && crrCodeObj.id)) {
        this.setState({ crrCodeObj: codeInitobj });
      }
    }
  }

  onSelectionChange = (value) => {
    // console.log("list--------.--------.--->", value)
    let { formData } = this.state;
    this.setState({ formData: { ...formData, list: value } });
  }

  onSubmit = () => {
    let { formData } = this.state;
    const data = {
      title: formData?.title ?? "",
      subject: formData?.subject ?? "",
      message: formData?.message ?? "",
      list: formData?.list ?? [],
      productList: formData?.productList ?? [],
      // productId: formData?.assessment ?? "",
      teamId: formData?.teamId ?? null,
      type: formData?.type ?? ""
    };

    const temp = {
      "keyWord": "",
      "pageNo": 1,
      "size": 10
    }
    this.props.dispatch(assessmentActions.saveCoachCampaign(data, temp));

    setTimeout(() => {
      this.setState({
        addCampaignsModal: false,
        formData: {
          title: "",
          subject: "",
          message: "",
          assessment: "",
          teamId: "",
          assessment: "talent28",
          type: "team",
          stage: 1
        }
      });
    }, 500)

  }

  onResponses = (data) => {
    this.props.history.push(`/assessment/responses/` + data.campaignId);
  }

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.getCoachCampaignList({
        pageNo,
        size,
        keyWord
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.pageNo !== this.state.pageNo ||
      prevState.size !== this.state.size ||
      prevState.keyWord !== this.state.keyWord
    ) {
      this.callUserListAPI();
    }
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getCoachCampaignList(data));
  }

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getCoachCampaignListTotal } = this.props.assessment;
    const totalPages = Math.ceil(getCoachCampaignListTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  handleProductSelect = (pId) => {
    this.setState((prevState) => {
      const productList = prevState.formData.productList || [];
      const updatedProductList = productList.includes(pId)
        ? productList.filter((id) => id !== pId) // Remove if exists
        : [...productList, pId];                 // Add if not

      return {
        formData: {
          ...prevState.formData,
          productList: updatedProductList
        },
      };
    });
  };


  render() {
    let { assessment } = this.props;
    const { crrCodeObj, addCampaignsModal, updateUserModal, entries, formData, pageNo, size } = this.state;
    let { getAvailableCodeCountData, userAssessmentUserProfileData, getCoachCampaignListData, getCoachCampaignListTotal, getTeamListData, getTeamListTotal,
      getMyUserListData, getMyUserListTotal, loading,
      getAssessmentProductsData } = assessment;

    const columns = [
      { key: "id", label: "S.No." },
      { key: "title", label: "Campaign Name" },
      { key: "launchdate", label: "Launch Date" },
      { key: "productName", label: "Product Name" },
    ];

    let data =
      Array.isArray(getCoachCampaignListData) && getCoachCampaignListData.length > 0
        ? getCoachCampaignListData.map((ele, i) => ({
          id: i + 1,
          campaignId: ele?.id ?? "",
          title: ele?.title ?? "-",
          teamName: ele?.teamId?.name ?? "-",
          teamId: ele?.teamId?.id ?? null,
          productName: ele?.productId?.name ?? null,
          launchdate: ele?.createdAt
            ? moment(ele.createdAt).format("DD MMMM, YYYY hh:mm")
            : "-",
          lastreminderdate: ele?.lastReminderDate
            ? moment(ele.lastReminderDate).format("DD MMMM, YYYY hh:mm")
            : "-",
          createdby: ele?.createdBy?.email ?? "-",
          // status: ele.isComplete ? "Completed" : (ele.isClicked ? "Pending" : "Not Started")
        }))
        : [];

    const start = getCoachCampaignListTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getCoachCampaignListTotal);
    const totalPages = Math.ceil(getCoachCampaignListTotal / size);

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };


    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf}>
        <div className="space-y-6 p-8">
          {/* Header Row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Heading className="text-lg" title="My Campaigns" />
            </div>
            <div className="flex items-center gap-3">
              <AddButton title="Add New" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openAddCampaignsModal} />
            </div>
          </div>

          {/* Table Section*/}
          <div className="overflow-x-auto bg-white border rounded-md p-4">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2 text-sm textblack">
                Show
                <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                entries
              </div>

              <div className="flex items-center gap-3 text-sm textblack">
                <div className="">
                  <SearchBox value={this.state.keyWord} onChange={this.handleSearch} placeholder="Search" />
                </div>
                <div>{start}-{end} of {getCoachCampaignListTotal}</div>
                <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                  <MdArrowBackIos size={20} />
                </div>
                <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                  <MdArrowForwardIos size={20} />
                </div>
              </div>
            </div>

            <CommonTableTeam
              columns={columns}
              onClick={() => { }}
              data={data}
              renderActions={(row) => (
                <div className="flex gap-2">
                  <Tooltip text="My Responses" position="top">
                    <div onClick={() => this.onResponses(row)} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-blue-100 hover:text-blue-600"><BsBarChartLine size={18} /></div>
                  </Tooltip>
                  <Tooltip text="Reminder" position="top">
                    <div onClick={() => ("")} className="p-2 cursor-pointer rounded bg-gray-100 text-black hover:bg-yellow-100 hover:text-yellow-600"><LuAlarmClock size={18} /></div>
                  </Tooltip>
                </div>
              )}
            />

            {!loading && !(data && data.length > 0) &&
              <div className="flex items-center justify-center">
                <div className="text-center py-8">
                  <div className="flex flex-col items-center justify-center text-gray-500">
                    <h1 className="text-lg font-semibold">No Data Found</h1>
                    <p className="text-sm mt-1">Try adjusting your search or filters</p>
                  </div>
                </div>
              </div>
            }

          </div>

        </div>

        {addCampaignsModal && (
          <AddCampaignsModal
            onClose={this.closeAddCampaignsModal}
            teamList={getTeamListData}
            formData={formData}
            handleChange={this.handleInputChange}
            handleProductSelect={this.handleProductSelect}
            onSubmitForm={this.onSubmitForm}
            getMyUserListData={getMyUserListData}
            onSelectionChange={this.onSelectionChange}
            onSubmit={this.onSubmit}
            codeCountList={getAvailableCodeCountData}
            crrCodeObj={crrCodeObj}
            productList={getAssessmentProductsData}
          />
        )}

        {updateUserModal && (
          <UpdateCampaignsModal
            isOpen={this.openUpdateCampaignsModal}
            onClose={this.closeUpdateCampaignsModal}
            onReupload={this.handleReupload}
          />
        )}

      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { assessment } = state;
  return {
    loggingIn,
    assessment
  };
}

export default connect(mapStateToProps)(MyCampaigns);

